import { defineNuxtPlugin } from '#app/nuxt'
import { LazyFrontendAccountCustomerGroupRegistrationPage, LazyFrontendDetailPage, LazyFrontendLandingPage, LazyFrontendNavigationPage, LazyLanguageSwitcher, LazyAccountAddressCard, LazyAccountAddressForm, LazyAccountChangePassword, LazyAccountLoginForm, LazyAccountMyAddress, LazyAccountMyLatestOrder, LazyAccountMyPaymentMethods, LazyAccountMyProfilChangePassword, LazyAccountMyProfile, LazyAccountMyProfileEditProfile, LazyAccountNavigation, LazyAccountOrderDetails, LazyAccountOrderDownloads, LazyAccountOrderLineItem, LazyAccountOrderSummary, LazyAccountPersonalData, LazyAccountRecoverPassword, LazyAccountRegisterForm, LazyAccountResetPasswordForm, LazyAccountSidebar, LazyAccountWishlistItem, LazyCategoryNavigation, LazyCategoryNavigationLink, LazyCheckoutAddressInput, LazyCheckoutCartItem, LazyCheckoutExpressOptions, LazyCheckoutFreeShippingInfoCart, LazyCheckoutOrderSuccessful, LazyCheckoutOrderSummaryBox, LazyCheckoutOrderVerification, LazyCheckoutPageCartItem, LazyCheckoutPayUponInvoiceLegal, LazyCheckoutPaymentMethods, LazyCheckoutPromotionCode, LazyCheckoutQuickRegister, LazyCheckoutSideCart, LazyCheckoutButtonAmazonPay, LazyCheckoutButtonAmazonPayExpress, LazyCheckoutButtonPayPalExpress, LazyCmsPage, LazyCmsBlockCategorySlider, LazyCmsBlockCountdown, LazyCmsBlockFaqs, LazyCmsBlockHeroSlider, LazyCmsBlockHtml, LazyCmsBlockUspBanner, LazyCmsElementCategoryNavigation, LazyCmsElementCategorySlider, LazyCmsElementCountdown, LazyCmsElementFaqs, LazyCmsElementHeroSlider, LazyCmsElementHtml, LazyCmsElementImage, LazyCmsElementImageGallery, LazyCmsElementImageSlider, LazyCmsElementProductBox, LazyCmsElementProductListing, LazyCmsElementProductSlider, LazyCmsElementSidebarFilter, LazyCmsElementText, LazyCmsElementUspBanner, LazyCmsSectionSidebar, LazyContactFormDescriptionUpload, LazyContactFormMachineInformation, LazyContactFormPersonalData, LazyContactFormSelectRepair, LazyContactFormStepInfoBox, LazyCustomProductListingFilters, LazyErrorsMaintainMode, LazyErrorsRoutingNotFound, LazyFilterAvailable, LazyFilterPrice, LazyFilterProperties, LazyFilterRating, LazyFilterShippingFree, LazyLayerMiniDrawer, LazyLayoutBreadcrumbs, LazyLayoutCheckoutHeader, LazyLayoutDisturberAdvantages, LazyLayoutDisturberBWare, LazyLayoutDisturberCustomerService, LazyLayoutDisturberSpareParts, LazyLayoutFooter, LazyLayoutFooterSmall, LazyLayoutHeader, LazyLayoutLastSeenList, LazyLayoutModalBackground, LazyLayoutModalsContainer, LazyLayoutNavigation, LazyLayoutNotification, LazyLayoutNotifications, LazyLayoutPaymentMethods, LazyLayoutSearchDesktop, LazyLayoutSearchMobile, LazyLayoutSearchResult, LazyLayoutSidebar, LazyLayoutTopBar, LazyListingFiltersSearchListingFilters, LazyNewsletterOptinSetupStructure, LazyProductActions, LazyProductAddToCart, LazyProductAvailability, LazyProductBadge, LazyProductCard, LazyProductCategoryCard, LazyProductCategoryGrid, LazyProductCategorySlider, LazyProductCompareFloatingButton, LazyProductCompareSidebar, LazyProductGallery, LazyProductListItem, LazyProductListingFilter, LazyProductPaypalPayRate, LazyProductPrice, LazyProductSlider, LazyProductStatic, LazyProductSuggestSearch, LazyProductUnits, LazyProductVariantConfigurator, LazyProductViewsAndSales, LazyProductDetails, LazyProductDetailsAccessories, LazyProductDetailsDescription, LazyProductDetailsDocuments, LazyProductDetailsFaq, LazyProductDetailsGpsr, LazyProductDetailsProperties, LazyProductDetailsPropertiesGroup, LazyProductDetailsSpareParts, LazyProductDetailsSparePartsPart, LazyScheppachAddressValidation, LazyScheppachCheckbox, LazyScheppachHeroSlider, LazyScheppachPasswordInput, LazyScheppachSpinner, LazyScheppachSpinnerSmall, LazyScheppachTextInput, LazySharedAccountAddressForm, LazySharedAddressForm, LazySharedCountryInput, LazySharedCountryStateInput, LazySharedDetailsSummary, LazySharedFileUpload, LazySharedHSlider, LazySharedImageUploader, LazySharedListingProductPrice, LazySharedMediaImage, LazySharedModal, LazySharedPagination, LazySharedPrice, LazySharedProductInformationExpand, LazySharedPromotionCode, LazySharedSelectableCard, LazySharedSelectableCardGroup, LazySharedSlider, LazySharedSparepartsManuals, LazySharedStepIndicator, LazySharedTooltip, LazySharedWarningBox, LazyNotification, LazySharedCountrySelectInput, LazySharedSelectInput, LazyProductDescription, LazySharedPasswordInput, LazySharedSpinner, LazySharedSpinnerSmall, LazySharedTextInput, LazyAltchaCaptcha, LazyCmsGenericBlock, LazyCmsGenericElement, LazyCmsNoComponent, LazyCmsBlockCategoryNavigation, LazyCmsBlockCenterText, LazyCmsBlockCrossSelling, LazyCmsBlockCustomForm, LazyCmsBlockDefault, LazyCmsBlockForm, LazyCmsBlockGalleryBuybox, LazyCmsBlockImage, LazyCmsBlockImageBubbleRow, LazyCmsBlockImageCover, LazyCmsBlockImageFourColumn, LazyCmsBlockImageGallery, LazyCmsBlockImageHighlightRow, LazyCmsBlockImageSimpleGrid, LazyCmsBlockImageSlider, LazyCmsBlockImageText, LazyCmsBlockImageTextBubble, LazyCmsBlockImageTextCover, LazyCmsBlockImageTextGallery, LazyCmsBlockImageTextRow, LazyCmsBlockImageThreeColumn, LazyCmsBlockImageThreeCover, LazyCmsBlockImageTwoColumn, LazyCmsBlockProductDescriptionReviews, LazyCmsBlockProductHeading, LazyCmsBlockProductListing, LazyCmsBlockProductSlider, LazyCmsBlockProductThreeColumn, LazyCmsBlockSidebarFilter, LazyCmsBlockText, LazyCmsBlockTextHero, LazyCmsBlockTextOnImage, LazyCmsBlockTextTeaser, LazyCmsBlockTextTeaserSection, LazyCmsBlockTextThreeColumn, LazyCmsBlockTextTwoColumn, LazyCmsBlockVimeoVideo, LazyCmsBlockYoutubeVideo, LazyCmsElementBuyBox, LazyCmsElementCrossSelling, LazyCmsElementCustomForm, LazyCmsElementForm, LazyCmsElementImageGallery3dPlaceholder, LazyCmsElementManufacturerLogo, LazyCmsElementProductDescriptionReviews, LazyCmsElementProductName, LazyCmsElementVimeoVideo, LazyCmsElementYoutubeVideo, LazyCmsSectionDefault, LazyProductCardSkeleton, LazyUnoIcon } from '#components'
const lazyGlobalComponents = [
  ["FrontendAccountCustomerGroupRegistrationPage", LazyFrontendAccountCustomerGroupRegistrationPage],
["FrontendDetailPage", LazyFrontendDetailPage],
["FrontendLandingPage", LazyFrontendLandingPage],
["FrontendNavigationPage", LazyFrontendNavigationPage],
["LanguageSwitcher", LazyLanguageSwitcher],
["AccountAddressCard", LazyAccountAddressCard],
["AccountAddressForm", LazyAccountAddressForm],
["AccountChangePassword", LazyAccountChangePassword],
["AccountLoginForm", LazyAccountLoginForm],
["AccountMyAddress", LazyAccountMyAddress],
["AccountMyLatestOrder", LazyAccountMyLatestOrder],
["AccountMyPaymentMethods", LazyAccountMyPaymentMethods],
["AccountMyProfilChangePassword", LazyAccountMyProfilChangePassword],
["AccountMyProfile", LazyAccountMyProfile],
["AccountMyProfileEditProfile", LazyAccountMyProfileEditProfile],
["AccountNavigation", LazyAccountNavigation],
["AccountOrderDetails", LazyAccountOrderDetails],
["AccountOrderDownloads", LazyAccountOrderDownloads],
["AccountOrderLineItem", LazyAccountOrderLineItem],
["AccountOrderSummary", LazyAccountOrderSummary],
["AccountPersonalData", LazyAccountPersonalData],
["AccountRecoverPassword", LazyAccountRecoverPassword],
["AccountRegisterForm", LazyAccountRegisterForm],
["AccountResetPasswordForm", LazyAccountResetPasswordForm],
["AccountSidebar", LazyAccountSidebar],
["AccountWishlistItem", LazyAccountWishlistItem],
["CategoryNavigation", LazyCategoryNavigation],
["CategoryNavigationLink", LazyCategoryNavigationLink],
["CheckoutAddressInput", LazyCheckoutAddressInput],
["CheckoutCartItem", LazyCheckoutCartItem],
["CheckoutExpressOptions", LazyCheckoutExpressOptions],
["CheckoutFreeShippingInfoCart", LazyCheckoutFreeShippingInfoCart],
["CheckoutOrderSuccessful", LazyCheckoutOrderSuccessful],
["CheckoutOrderSummaryBox", LazyCheckoutOrderSummaryBox],
["CheckoutOrderVerification", LazyCheckoutOrderVerification],
["CheckoutPageCartItem", LazyCheckoutPageCartItem],
["CheckoutPayUponInvoiceLegal", LazyCheckoutPayUponInvoiceLegal],
["CheckoutPaymentMethods", LazyCheckoutPaymentMethods],
["CheckoutPromotionCode", LazyCheckoutPromotionCode],
["CheckoutQuickRegister", LazyCheckoutQuickRegister],
["CheckoutSideCart", LazyCheckoutSideCart],
["CheckoutButtonAmazonPay", LazyCheckoutButtonAmazonPay],
["CheckoutButtonAmazonPayExpress", LazyCheckoutButtonAmazonPayExpress],
["CheckoutButtonPayPalExpress", LazyCheckoutButtonPayPalExpress],
["CmsPage", LazyCmsPage],
["CmsBlockCategorySlider", LazyCmsBlockCategorySlider],
["CmsBlockCountdown", LazyCmsBlockCountdown],
["CmsBlockFaqs", LazyCmsBlockFaqs],
["CmsBlockHeroSlider", LazyCmsBlockHeroSlider],
["CmsBlockHtml", LazyCmsBlockHtml],
["CmsBlockUspBanner", LazyCmsBlockUspBanner],
["CmsElementCategoryNavigation", LazyCmsElementCategoryNavigation],
["CmsElementCategorySlider", LazyCmsElementCategorySlider],
["CmsElementCountdown", LazyCmsElementCountdown],
["CmsElementFaqs", LazyCmsElementFaqs],
["CmsElementHeroSlider", LazyCmsElementHeroSlider],
["CmsElementHtml", LazyCmsElementHtml],
["CmsElementImage", LazyCmsElementImage],
["CmsElementImageGallery", LazyCmsElementImageGallery],
["CmsElementImageSlider", LazyCmsElementImageSlider],
["CmsElementProductBox", LazyCmsElementProductBox],
["CmsElementProductListing", LazyCmsElementProductListing],
["CmsElementProductSlider", LazyCmsElementProductSlider],
["CmsElementSidebarFilter", LazyCmsElementSidebarFilter],
["CmsElementText", LazyCmsElementText],
["CmsElementUspBanner", LazyCmsElementUspBanner],
["CmsSectionSidebar", LazyCmsSectionSidebar],
["ContactFormDescriptionUpload", LazyContactFormDescriptionUpload],
["ContactFormMachineInformation", LazyContactFormMachineInformation],
["ContactFormPersonalData", LazyContactFormPersonalData],
["ContactFormSelectRepair", LazyContactFormSelectRepair],
["ContactFormStepInfoBox", LazyContactFormStepInfoBox],
["CustomProductListingFilters", LazyCustomProductListingFilters],
["ErrorsMaintainMode", LazyErrorsMaintainMode],
["ErrorsRoutingNotFound", LazyErrorsRoutingNotFound],
["FilterAvailable", LazyFilterAvailable],
["FilterPrice", LazyFilterPrice],
["FilterProperties", LazyFilterProperties],
["FilterRating", LazyFilterRating],
["FilterShippingFree", LazyFilterShippingFree],
["LayerMiniDrawer", LazyLayerMiniDrawer],
["LayoutBreadcrumbs", LazyLayoutBreadcrumbs],
["LayoutCheckoutHeader", LazyLayoutCheckoutHeader],
["LayoutDisturberAdvantages", LazyLayoutDisturberAdvantages],
["LayoutDisturberBWare", LazyLayoutDisturberBWare],
["LayoutDisturberCustomerService", LazyLayoutDisturberCustomerService],
["LayoutDisturberSpareParts", LazyLayoutDisturberSpareParts],
["LayoutFooter", LazyLayoutFooter],
["LayoutFooterSmall", LazyLayoutFooterSmall],
["LayoutHeader", LazyLayoutHeader],
["LayoutLastSeenList", LazyLayoutLastSeenList],
["LayoutModalBackground", LazyLayoutModalBackground],
["LayoutModalsContainer", LazyLayoutModalsContainer],
["LayoutNavigation", LazyLayoutNavigation],
["LayoutNotification", LazyLayoutNotification],
["LayoutNotifications", LazyLayoutNotifications],
["LayoutPaymentMethods", LazyLayoutPaymentMethods],
["LayoutSearchDesktop", LazyLayoutSearchDesktop],
["LayoutSearchMobile", LazyLayoutSearchMobile],
["LayoutSearchResult", LazyLayoutSearchResult],
["LayoutSidebar", LazyLayoutSidebar],
["LayoutTopBar", LazyLayoutTopBar],
["ListingFiltersSearchListingFilters", LazyListingFiltersSearchListingFilters],
["NewsletterOptinSetupStructure", LazyNewsletterOptinSetupStructure],
["ProductActions", LazyProductActions],
["ProductAddToCart", LazyProductAddToCart],
["ProductAvailability", LazyProductAvailability],
["ProductBadge", LazyProductBadge],
["ProductCard", LazyProductCard],
["ProductCategoryCard", LazyProductCategoryCard],
["ProductCategoryGrid", LazyProductCategoryGrid],
["ProductCategorySlider", LazyProductCategorySlider],
["ProductCompareFloatingButton", LazyProductCompareFloatingButton],
["ProductCompareSidebar", LazyProductCompareSidebar],
["ProductGallery", LazyProductGallery],
["ProductListItem", LazyProductListItem],
["ProductListingFilter", LazyProductListingFilter],
["ProductPaypalPayRate", LazyProductPaypalPayRate],
["ProductPrice", LazyProductPrice],
["ProductSlider", LazyProductSlider],
["ProductStatic", LazyProductStatic],
["ProductSuggestSearch", LazyProductSuggestSearch],
["ProductUnits", LazyProductUnits],
["ProductVariantConfigurator", LazyProductVariantConfigurator],
["ProductViewsAndSales", LazyProductViewsAndSales],
["ProductDetails", LazyProductDetails],
["ProductDetailsAccessories", LazyProductDetailsAccessories],
["ProductDetailsDescription", LazyProductDetailsDescription],
["ProductDetailsDocuments", LazyProductDetailsDocuments],
["ProductDetailsFaq", LazyProductDetailsFaq],
["ProductDetailsGpsr", LazyProductDetailsGpsr],
["ProductDetailsProperties", LazyProductDetailsProperties],
["ProductDetailsPropertiesGroup", LazyProductDetailsPropertiesGroup],
["ProductDetailsSpareParts", LazyProductDetailsSpareParts],
["ProductDetailsSparePartsPart", LazyProductDetailsSparePartsPart],
["ScheppachAddressValidation", LazyScheppachAddressValidation],
["ScheppachCheckbox", LazyScheppachCheckbox],
["ScheppachHeroSlider", LazyScheppachHeroSlider],
["ScheppachPasswordInput", LazyScheppachPasswordInput],
["ScheppachSpinner", LazyScheppachSpinner],
["ScheppachSpinnerSmall", LazyScheppachSpinnerSmall],
["ScheppachTextInput", LazyScheppachTextInput],
["SharedAccountAddressForm", LazySharedAccountAddressForm],
["SharedAddressForm", LazySharedAddressForm],
["SharedCountryInput", LazySharedCountryInput],
["SharedCountryStateInput", LazySharedCountryStateInput],
["SharedDetailsSummary", LazySharedDetailsSummary],
["SharedFileUpload", LazySharedFileUpload],
["SharedHSlider", LazySharedHSlider],
["SharedImageUploader", LazySharedImageUploader],
["SharedListingProductPrice", LazySharedListingProductPrice],
["SharedMediaImage", LazySharedMediaImage],
["SharedModal", LazySharedModal],
["SharedPagination", LazySharedPagination],
["SharedPrice", LazySharedPrice],
["SharedProductInformationExpand", LazySharedProductInformationExpand],
["SharedPromotionCode", LazySharedPromotionCode],
["SharedSelectableCard", LazySharedSelectableCard],
["SharedSelectableCardGroup", LazySharedSelectableCardGroup],
["SharedSlider", LazySharedSlider],
["SharedSparepartsManuals", LazySharedSparepartsManuals],
["SharedStepIndicator", LazySharedStepIndicator],
["SharedTooltip", LazySharedTooltip],
["SharedWarningBox", LazySharedWarningBox],
["Notification", LazyNotification],
["SharedCountrySelectInput", LazySharedCountrySelectInput],
["SharedSelectInput", LazySharedSelectInput],
["ProductDescription", LazyProductDescription],
["SharedPasswordInput", LazySharedPasswordInput],
["SharedSpinner", LazySharedSpinner],
["SharedSpinnerSmall", LazySharedSpinnerSmall],
["SharedTextInput", LazySharedTextInput],
["AltchaCaptcha", LazyAltchaCaptcha],
["CmsGenericBlock", LazyCmsGenericBlock],
["CmsGenericElement", LazyCmsGenericElement],
["CmsNoComponent", LazyCmsNoComponent],
["CmsBlockCategoryNavigation", LazyCmsBlockCategoryNavigation],
["CmsBlockCenterText", LazyCmsBlockCenterText],
["CmsBlockCrossSelling", LazyCmsBlockCrossSelling],
["CmsBlockCustomForm", LazyCmsBlockCustomForm],
["CmsBlockDefault", LazyCmsBlockDefault],
["CmsBlockForm", LazyCmsBlockForm],
["CmsBlockGalleryBuybox", LazyCmsBlockGalleryBuybox],
["CmsBlockImage", LazyCmsBlockImage],
["CmsBlockImageBubbleRow", LazyCmsBlockImageBubbleRow],
["CmsBlockImageCover", LazyCmsBlockImageCover],
["CmsBlockImageFourColumn", LazyCmsBlockImageFourColumn],
["CmsBlockImageGallery", LazyCmsBlockImageGallery],
["CmsBlockImageHighlightRow", LazyCmsBlockImageHighlightRow],
["CmsBlockImageSimpleGrid", LazyCmsBlockImageSimpleGrid],
["CmsBlockImageSlider", LazyCmsBlockImageSlider],
["CmsBlockImageText", LazyCmsBlockImageText],
["CmsBlockImageTextBubble", LazyCmsBlockImageTextBubble],
["CmsBlockImageTextCover", LazyCmsBlockImageTextCover],
["CmsBlockImageTextGallery", LazyCmsBlockImageTextGallery],
["CmsBlockImageTextRow", LazyCmsBlockImageTextRow],
["CmsBlockImageThreeColumn", LazyCmsBlockImageThreeColumn],
["CmsBlockImageThreeCover", LazyCmsBlockImageThreeCover],
["CmsBlockImageTwoColumn", LazyCmsBlockImageTwoColumn],
["CmsBlockProductDescriptionReviews", LazyCmsBlockProductDescriptionReviews],
["CmsBlockProductHeading", LazyCmsBlockProductHeading],
["CmsBlockProductListing", LazyCmsBlockProductListing],
["CmsBlockProductSlider", LazyCmsBlockProductSlider],
["CmsBlockProductThreeColumn", LazyCmsBlockProductThreeColumn],
["CmsBlockSidebarFilter", LazyCmsBlockSidebarFilter],
["CmsBlockText", LazyCmsBlockText],
["CmsBlockTextHero", LazyCmsBlockTextHero],
["CmsBlockTextOnImage", LazyCmsBlockTextOnImage],
["CmsBlockTextTeaser", LazyCmsBlockTextTeaser],
["CmsBlockTextTeaserSection", LazyCmsBlockTextTeaserSection],
["CmsBlockTextThreeColumn", LazyCmsBlockTextThreeColumn],
["CmsBlockTextTwoColumn", LazyCmsBlockTextTwoColumn],
["CmsBlockVimeoVideo", LazyCmsBlockVimeoVideo],
["CmsBlockYoutubeVideo", LazyCmsBlockYoutubeVideo],
["CmsElementBuyBox", LazyCmsElementBuyBox],
["CmsElementCrossSelling", LazyCmsElementCrossSelling],
["CmsElementCustomForm", LazyCmsElementCustomForm],
["CmsElementForm", LazyCmsElementForm],
["CmsElementImageGallery3dPlaceholder", LazyCmsElementImageGallery3dPlaceholder],
["CmsElementManufacturerLogo", LazyCmsElementManufacturerLogo],
["CmsElementProductDescriptionReviews", LazyCmsElementProductDescriptionReviews],
["CmsElementProductName", LazyCmsElementProductName],
["CmsElementVimeoVideo", LazyCmsElementVimeoVideo],
["CmsElementYoutubeVideo", LazyCmsElementYoutubeVideo],
["CmsSectionDefault", LazyCmsSectionDefault],
["ProductCardSkeleton", LazyProductCardSkeleton],
["UnoIcon", LazyUnoIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
